import React from "react";
import RestaurantList from "./RestaurantList";
import EditBusiness from "./EditBusiness";

const Business = () => {
  const isStaff = window.location.pathname.includes('/restaurant-staff');
  
  if (isStaff) {
    return <EditBusiness />;
  }
  
  return <RestaurantList mode="business" />;
};

export default Business;
